import { layoutFeature } from "scenes/Layout/Layout";
import { mainFeature } from "scenes/MainPage/MainPage";
import { errorFeature } from "scenes/ErrorPage/ErrorPage";
import { imageDetectionFeature } from "scenes/ImageDetectionPage/ImageDetectionPage";
import { mapFeature } from "scenes/MapPage/MapPage";
import { projectReportFeature } from "scenes/ProjectReportPage/ProjectReportPage";
import { authFeature } from "scenes/AuthPage/AuthPage";
import { settingsFeature } from "scenes/SettingsPage/SettingsPage";
import { teamAndStaffFeature } from "scenes/TeamAndStaffPage/TeamAndStaffPage";
import { modalFeature } from "scenes/Modal/Modal";
import { unitsManagerFeature } from "scenes/UnitsManager/UnitsManager";
import { layersManagerFeature } from "scenes/LayersManager/LayersManager";
import { missionsManagerFeature } from "scenes/MissionsManager/MissionsManager";
import { FeaturesName } from "./interfaces";

export const features = {
  [FeaturesName.LAYOUT]: layoutFeature,
  [FeaturesName.MAIN]: mainFeature,
  [FeaturesName.ERROR]: errorFeature,
  [FeaturesName.IMAGE_DETECTION]: imageDetectionFeature,
  [FeaturesName.MAP]: mapFeature,
  [FeaturesName.PROJECT_REPORT]: projectReportFeature,
  [FeaturesName.SETTINGS]: settingsFeature,
  [FeaturesName.TEAM_AND_STAFF]: teamAndStaffFeature,
  [FeaturesName.AUTH]: authFeature,
  [FeaturesName.MODAL]: modalFeature,
  [FeaturesName.UNITS_MANAGER]: unitsManagerFeature,
  [FeaturesName.LAYERS_MANAGER]: layersManagerFeature,
  [FeaturesName.MISSIONS_MANAGER]: missionsManagerFeature
};

export const featureRegistry = Object.entries(features).map(
  ([name, module]) => ({ name: name as FeaturesName, module })
);
